<template>
    <div class="cc-payment" v-if="shouldPaymentBeShown" @click="setPayment(payment.uniqueName)">
        <div class="cc-payment__selector">
            <div class="cc-selector cc-selector--radio cc-selector--medium" v-bind:class="{'cc-active': isPaymentSelectedPayment}"></div>
        </div>
        <div class="cc-payment__thumbnail" v-if="payment.img">
            <img :src="payment.img" :alt="payment.title" class="cc-payment__image"/>
        </div>
        <div class="cc-payment__main" v-bind:class="{'cc-thumbnail-exists': payment.img}">
            <div class="cc-payment__title">{{ payment.title }}</div>
        </div>
        <div class="cc-payment__prices">
            <div class="cc-price cc-price--payment">{{ displayPaymentPrice }}</div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                selectedPayment: state => state.selectedPayment,
            }),
            shouldPaymentBeShown: function () {
                if (this.selectedPayment && this.selectedPayment === this.payment.uniqueName) {
                    return true;
                }

                if (this.selectedPayment === null && this.payment.active === true) {
                    return true;
                }

                return false;
            },
            isPaymentSelectedPayment: function () {
                return this.payment.uniqueName === this.selectedPayment;
            },
            displayPaymentPrice: function () {
                return this.payment.free ? this.translations['Free'] : this.payment.formattedPrices.price;
            },
        },
        methods: {
            setPayment: function (uniqueName) {
                this.$store.dispatch('SELECT_PAYMENT', uniqueName).then(function () {
                    document.querySelector('.cc-theme--globalmoto__payments').scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                });
            },
        },
        name: 'Payment',
        props: [
            'payment',
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/payment";
</style>
